import {SERVICE_PROFILE_NEW} from '@shared/config';
import widgetApiEndpoints from '../../../widgetApiEndpoints';

export default widgetApiEndpoints({[SERVICE_PROFILE_NEW]: ['tmt/user']});
